import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=7353954c"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=7353954c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports